import * as React from "react";
import "./loaderSpinner.css";

interface LoaderSpinnerProps {
}

export class LoaderSpinner extends React.Component<LoaderSpinnerProps> {


  render() {
    return <div className="lds-roller">
      <div/>
      <div/>
      <div/>
      <div/>
      <div/>
      <div/>
      <div/>
      <div/>
    </div>
  }
}